export default {"src":"/_next/static/media/WalletSDKDark.57b1e790.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};